import React from 'react';
import { Section } from './ui/Section';
import { Check, X } from 'lucide-react';
export function ForWhom() {
  return <Section className="bg-section" data-id="element-82">
      <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-12" data-id="element-83">
        Para quién es / No es
      </h2>

      <div className="grid md:grid-cols-2 gap-8" data-id="element-84">
        {/* Is For You */}
        <div className="bg-primary/50 p-8 rounded-2xl border border-green-500/20" data-id="element-85">
          <h3 className="text-2xl font-bold text-green-400 mb-6 flex items-center" data-id="element-86">
            <Check className="mr-2" data-id="element-87" /> Es para ti si:
          </h3>
          <ul className="space-y-4" data-id="element-88">
            {['Vendes (o quieres vender) un producto digital low ticket', 'Te abruma lo técnico y necesitas una ruta simple', "Quieres ejecutar hoy, no 'aprender un mes'"].map((item, i) => <li key={i} className="flex items-start text-text-secondary" data-id="element-89">
                <div className="w-1.5 h-1.5 bg-green-500 rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-90" />
                {item}
              </li>)}
          </ul>
        </div>

        {/* Not For You */}
        <div className="bg-primary/50 p-8 rounded-2xl border border-red-500/20" data-id="element-91">
          <h3 className="text-2xl font-bold text-red-400 mb-6 flex items-center" data-id="element-92">
            <X className="mr-2" data-id="element-93" /> No es para ti si:
          </h3>
          <ul className="space-y-4" data-id="element-94">
            {['Estás buscando automatización total desde el día 1', "Quieres construir 'la marca perfecta' antes de vender", 'No tienes nada que ofrecer todavía'].map((item, i) => <li key={i} className="flex items-start text-text-secondary" data-id="element-95">
                <div className="w-1.5 h-1.5 bg-red-500 rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-96" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}